import type { TarifPageVariant } from '@workspace/core-ts/components';

const textes = {
    page: {
        titre: 'Vos garanties',
        sousTitre: '',
    },
    formule: {
        recommande: 'Recommandée',
        renforcee: 'Renforcée',
        selectionne: 'Sélectionnée',
        selectionner: 'Sélectionner',
    },
    unites: {
        mois: 'mois',
        an: 'an',
        soit: 'soit',
        dont: 'dont',
    },
    option: {
        capitalInvalidite: 'Indemnisation',
    },
    codePromo: {
        titre: 'Vous avez un code promo ?',
        placeholder: 'Code promo',
        valider: 'Valider',
        invalide: "Le code promo n'est pas valide.",
        valide: 'Le code promo a bien été appliqué.',
    },
    documents: {
        titre: 'Documents contractuels',
    },
    recapitulatif: {
        titre: 'Votre tarif',
    },
    navigation: {
        continuer: 'Continuer',
        recevoirEmail: 'Recevoir ma proposition par email',
    },
};

const formulesConfigMeta = [
    {
        code: 'F1',
        description: 'Protection essentielle pour votre vélo',
        recommande: true,
    },
];

interface GarantieConfig {
    code: string;
    nom: string;
    description: string;
    plafonds?: Array<{
        label: string;
        montant: string;
        detail?: string;
    }>;
    details?: string[];
}

const garantiesConfig: GarantieConfig[] = [
    {
        code: 'VI',
        nom: 'Vol et tentative de vol',
        description: 'Indemnisation en cas de vol de votre vélo avec effraction ou agression.',
        plafonds: [
            { label: 'Vol', montant: 'Franchise 5% de la valeur d’achat TTC', detail: 'avec minimum 100€' },
            { label: 'Tentative de vol', montant: 'Franchise 10% du montant des dommages', detail: 'avec minimum 50€' },
        ],
    },
    {
        code: 'DTA',
        nom: 'Dommages matériels et casse',
        description: 'Prise en charge des réparations en cas de dommages accidentels sur votre vélo.',
        plafonds: [{ label: 'Franchise', montant: 'Franchise 10% du montant des dommages', detail: 'avec minimum 50€' }],
    },
    {
        code: 'CN',
        nom: 'Catastrophes naturelles',
        description: 'Protection contre les dommages liés aux catastrophes naturelles.',
        plafonds: [{ label: 'Franchise', montant: '380€', detail: 'Franchise légale' }],
    },
    {
        code: 'CT',
        nom: 'Catastrophes technologiques',
        description: 'Couverture en cas de catastrophe technologique.',
        plafonds: [{ label: 'Franchise', montant: 'Sans franchise' }],
    },
    {
        code: 'PCC1',
        nom: 'Protection corporelle du cycliste',
        description: "Protection renforcée couvrant l'utilisateur du vélo et l'enfant transporté en cas d'accident.",
        plafonds: [
            { label: 'Indemnisation', montant: '100 000€', detail: 'avec franchise 15% en AIPP' },
            { label: 'Décès', montant: '15 000€' },
        ],
    },
];

const garantiesExclues = ['PCC1'];

const optionProtectionCorporelleConfig = {
    code: 'PCC1',
    description: "La seule garantie qui couvre l'utilisateur du vélo et l'enfant transporté !",
    avantages: {
        capitalApres: '100 000€ en cas d’invalidité (≥15% d’AIPP)',
        texteSecondaire:
            "Et quel que soit votre taux d'invalidité, nous prenons en charge vos frais médicaux (y compris frais de rééducation, de lunetterie et dentaires) jusqu'à 1 500 € ! Pour l'enfant transporté et accidenté, nous prenons en charge, également, jusqu'à 40 h d'école à domicile afin qu'il puisse continuer à suivre son programme scolaire.",
    },
};

export const veloVariant: TarifPageVariant = {
    variant: 'amo',
    defaultFormule: 'F1',
    optionCode: 'PCC1',
    formulesConfigMeta,
    garantiesConfig,
    garantiesExclues,
    optionIndividuelleConfig: optionProtectionCorporelleConfig,
    textes,
    optionFormuleTarget: 'F1',
    commissionConfig: {
        showTauxApporteur: true,
        tauxApporteurLocked: true,
    },
};

// Re-exports pour compatibilité
export { formulesConfigMeta, garantiesConfig, garantiesExclues, optionProtectionCorporelleConfig, textes };
export type { GarantieConfig };
